import { j as o } from "../../jsx-runtime-ClSzPYp4.js";
import { useState as B, useEffect as p } from "react";
import { styled as u, useTheme as j } from "styled-components";
import s from "../../Button/Button.mjs";
import { Flex as m, Box as w } from "../../Flexbox/Flexbox.mjs";
import { a as I } from "../../brands-CoixlYYY.js";
import { generateId as O } from "../../common/utils/index.mjs";
import { useBrand as A } from "../../providers/BrandProvider/brandProvider.mjs";
import g from "../../typography/Heading/Heading.mjs";
import y from "../../typography/Link/Link.mjs";
import _ from "../../typography/Paragraph/Paragraph.mjs";
import { COOKIE_MANAGEMENT_EVENT_ACTION as i } from "../cookieManagementTypes.mjs";
import E from "../hooks/useCookieBanner.mjs";
import T from "../utils/expireInvalidCookies.mjs";
import b from "./cookieBannerPolicyLinks.mjs";
import "@react-spring/web";
import "../../focus-trap-react-Bogv-_bG.js";
import "react-dom";
import "styled-system";
import "../../index.esm-DOxVcNnO.js";
import "../../Icon/StyledPath.mjs";
import "../../RadioGroup/Radio.mjs";
import "../../RadioGroup/RadioGroup.mjs";
import "../../typography/Text/Text.mjs";
import "../FullPageCookieBanner/FullPageHideOnError.mjs";
import v from "./CookieBannerModal.mjs";
import N from "./HideOnError.mjs";
const R = ({ allowRejectAll: r = !0, id: f = O(), allowList: l = I, policyLinks: d = b, onCookieManagementEvent: e }) => {
  const x = A(l), t = /* @__PURE__ */ j(), [h, c] = B(!1), n = (C) => {
    k({
      ...C,
      onCookieManagementEvent: e
    });
  };
  p(() => {
    T();
  }, []);
  const { shouldDisplayCookieBanner: a, updatePreferences: k } = E({
    onCookieManagementEvent: e
  });
  return p(() => {
    a && e(i.BANNER_FIRST_RENDER);
  }, [
    a,
    e
  ]), a ? /* @__PURE__ */ o.jsxs(o.Fragment, {
    children: [
      /* @__PURE__ */ o.jsx(S, {
        "data-qa-id": f,
        borderTop: "0.2rem solid",
        paddingX: [
          "lg",
          0
        ],
        width: "100%",
        zIndex: t.components.cookieBanner.zIndex,
        children: /* @__PURE__ */ o.jsxs(m, {
          flexDirection: [
            "column",
            "row"
          ],
          justifyContent: "center",
          mx: "auto",
          my: "md",
          maxWidth: "150rem",
          children: [
            /* @__PURE__ */ o.jsxs(w, {
              my: "auto",
              children: [
                /* @__PURE__ */ o.jsx(L, {
                  size: "small",
                  level: "2",
                  textAlign: "left",
                  children: "Your cookie preferences"
                }),
                /* @__PURE__ */ o.jsxs(_, {
                  paddingX: [
                    "sm",
                    "md"
                  ],
                  paddingY: "xs",
                  variant: t.components.cookieBanner.textVariant,
                  children: [
                    "Cookies help us improve your website experience, and make sure you're only shown ads that are relevant to you. To find out more,",
                    " ",
                    /* @__PURE__ */ o.jsx(y, {
                      external: !0,
                      href: d[x],
                      variant: t.components.cookieBanner.textVariant,
                      children: "read our Cookie Policy."
                    })
                  ]
                })
              ]
            }),
            /* @__PURE__ */ o.jsxs(m, {
              flexDirection: [
                "column",
                null,
                null,
                null,
                "row"
              ],
              width: [
                "100%",
                "auto"
              ],
              flexShrink: 0,
              my: "auto",
              marginTop: [
                "sm",
                "auto"
              ],
              gap: "xs",
              children: [
                /* @__PURE__ */ o.jsx(s, {
                  "data-qa-id": "accept-all-button",
                  width: [
                    "90%",
                    "auto"
                  ],
                  mx: [
                    "sm"
                  ],
                  onClick: () => {
                    n({
                      allowSiteImprovementCookies: !0,
                      allowAdvertisingCookies: !0
                    }), e(i.ACCEPT_ALL_COOKIES);
                  },
                  children: "Accept all"
                }),
                r && /* @__PURE__ */ o.jsx(s, {
                  "data-qa-id": "reject-all-button",
                  variant: t.components.cookieBanner.rejectButtonVariant,
                  width: [
                    "90%",
                    "auto"
                  ],
                  mx: [
                    "sm"
                  ],
                  onClick: () => {
                    n({
                      allowSiteImprovementCookies: !1,
                      allowAdvertisingCookies: !1
                    }), e(i.REJECT_ALL_COOKIES);
                  },
                  children: "Reject all"
                }),
                /* @__PURE__ */ o.jsx(s, {
                  "data-qa-id": "manage-cookies-button",
                  variant: t.components.cookieBanner.manageButtonVariant,
                  width: [
                    "90%",
                    "auto"
                  ],
                  mx: [
                    "sm"
                  ],
                  onClick: () => {
                    c(!0), e == null || e(i.OPEN_COOKIE_MODAL);
                  },
                  children: "Manage cookies"
                })
              ]
            })
          ]
        })
      }),
      /* @__PURE__ */ o.jsx(v, {
        isOpen: h,
        allowList: l,
        policyLinks: d,
        onClose: () => c(!1),
        setCookieLevel: n
      })
    ]
  }) : null;
}, S = /* @__PURE__ */ u(m).withConfig({
  componentId: "sc-b807d8ff-0"
})([
  "",
  ""
], ({ theme: r }) => r.components.cookieBanner.wrapper), L = /* @__PURE__ */ u(g).withConfig({
  componentId: "sc-b807d8ff-1"
})([
  "",
  ""
], ({ theme: r }) => r.components.cookieBanner.heading), lo = (r) => /* @__PURE__ */ o.jsx(N, {
  onCookieManagementEvent: r.onCookieManagementEvent,
  children: /* @__PURE__ */ o.jsx(R, {
    ...r
  })
});
export {
  R as CookieBannerRaw,
  lo as default
};
